import { colors, css, frames, icons, useMediaQuery } from "../../Styles/index"
import { useTranslation } from "react-i18next"
import "../../Translations/index"
import { Button, ButtonList } from "../../Components"
import { NavigationFunction, Pages } from "../Routers/CloudPanel/systemMenu_Router"
import { useNavigate } from "react-router"
import "../../Components/languageSelector"
import { StyleObject } from "styletron-react"
import { useMemo } from "react"
import { ListStyle_Types } from "../../Definitions"

interface SystemMenu_Props {
  overrides?:{
      gridArea?: string
  } 
}

export default function SystemMenu({overrides}:SystemMenu_Props) {
  const navigator = useNavigate()
  const {t} = useTranslation()
  const mobile = useMediaQuery(`(max-width: 1000px)`);
  
  const BtnFunc_Router = (btn_Index:number) => {
    switch (btn_Index) {
      case 0: 
        NavigationFunction(navigator, Pages.autopig)
        break
      case 1: 
        NavigationFunction(navigator, Pages.freeda_lf)
        break
      default:
        console.log("Error, page not found")
    }
  }

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
        {} as StyleObject, //default stlye
        overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])

  return (
    <frames.SystemMenu $style={_Root}>
      <ButtonList 
        contents={["Demo", "Farrowing Unit", "Demo", "Demo", "Demo"]}
        subContents={["Freeda Walk-Through", "Freeda Location Feeder", "Freeda Walk-In", "Freeda PPT", "Freeda Sorting"]}
        onClick={(i) => {if (i === 1) NavigationFunction(navigator, Pages.freeda_lf)}}
        startEnhancers={[icons.freedaESF_WalkThrough, icons.freedaLF, icons.freedaESF_WalkIn, icons.freedaPPT, icons.freedaSorter]}
        hasActiveLoad={true}
        overrides={{
          baseButton: {justifyContent: "start", width: mobile? "100%" : "270px"},
          hoverStyles: {backgroundColor: colors.blueDarkPrimary},
          contentStyles: {textAlign: "left"},
          subContentStyles: {textAlign: "left", color: colors.greyPrimary}
        }}
        listOverrides={{
          useNavigationControl: "system_index",
          listStyle: ListStyle_Types.vertical,
          listWidth: "100%"
        }}
        disabled={[true, false, true, true, true ]}
      />
    </frames.SystemMenu>
  )

}
